import { MAIN_CONTROLLER } from "@/utils/main_controller.js";
import { PREPOPULATE_INPUT } from "@/utils/prepopulate_input.js";
import { API_BASE_URL } from "@/config";
import { validateToken } from '@/utils/auth';
import BreadCrumb from "@/components/BreadCrumb/BreadCrumb.vue";
import ClientLogo from "@/components/ClientLogo/ClientLogo.vue";

export default {
  name: 'RefugeeVerificationService',
  mixins: [MAIN_CONTROLLER, PREPOPULATE_INPUT],
  components: {
    BreadCrumb,
    ClientLogo

  },
  data() {
    return {
      refugee_number: '',
      is_field_disabled: {
        refugee_number: false
      }
    }
  },

computed: {
    workflow_id() {
      return this.$store.getters.get_workflow_id;
    },

  },

  methods: {
    allow_alphanumeric(event) {
      const value = event.target.value;
      const sanitized = value.replace(/[^a-zA-Z0-9]/g, '');
      this.refugee_number = sanitized;
      event.target.value = sanitized;
      
      this.hide_error_messages();
    },

    verify_refugee() {
      this.hide_error_messages();

      if (!this.validate_refugee_number()) {
        return;
      }

      this.refugee_verification_api();
    },

    
    hide_error_messages() {
      document.querySelectorAll('.refugee-message, .invalid-message').forEach(el => {
        el.classList.add('d-none');
      });
    },
    
    show_error_message(type) {
      const element = document.querySelector(`.${type}-message`);
      if (element) {
        element.classList.remove('d-none');
      }
    },
    
    validate_refugee_number() {
      const trimmed_number = this.refugee_number.trim();
      
      if (!trimmed_number) {
        this.show_error_message('refugee');
        return false;
      }
      
      if (trimmed_number.length < 6 || trimmed_number.length > 15) {
        this.show_error_message('invalid');
        return false;
      }
      
      return true;
    },
    
    refugee_verification_api() {
      const TOKEN = localStorage.getItem('token');
      const REFUGEE_VERIFICATION_API = `${API_BASE_URL}/verify_api/personnel_verification/refugee_verification_api/`;

      this.error = '';

      $.ajax({
        url: REFUGEE_VERIFICATION_API,
        method: 'POST',
        contentType: 'application/json',
        headers: {
          Authorization: `Token ${TOKEN}`
        },
        data: JSON.stringify({
          refugee_number: this.refugee_number,
          workflow_id: this.workflow_id,
          on_behalf_application: this.$route.name === 'behalf_application' ? true : false,
        }),
        beforeSend: () => {
          Swal.fire({
            text: 'Loading ...',
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => Swal.showLoading(),
          });
        },
        success: () => {
            Swal.close();

          this.completeService();
        },
        error: (error) => {
          console.error(error)
          Swal.close();
          Swal.fire({
            icon: 'error',
            title: 'invalid refugee number',
            text: "please provide a valid refugee number",
            showConfirmButton: true,
          });
        }
      });
    },

  mounted() {
    if (!validateToken(this.$router)) {
      return;
    }
  },
  }
}
